import React, { useState, useEffect } from "react";

import "../aseets/css/Career.css";
import seoExpert from '../aseets/gallery/seo-expert.jpg';
import graphic from '../aseets/gallery/graphic-designer.jpg';
import developer from '../aseets/gallery/web-developer.jpg';
import editor from '../aseets/gallery/video-editor.jpg';

import './FeaturedJobOffers';
import FeaturedJobOffers from "./FeaturedJobOffers";

const cardData = [
    {
        id: 1,
        img: seoExpert,
        stats: "2 job offers\nSEO Expert",
    },
    {
        id: 2,
        img: developer,
        stats: "3 job offers\nWeb Developer",
    },
    {
        id: 3,
        img: editor,
        stats: "4 job offers\nVideo Editor",
    },
    {
        id: 4,
        img: graphic,
        stats: "2 job offers\UI / UX Design",
    },
];

const CareerHero = () => {
    
    useEffect(() => {
  const section = document.querySelector(".career-hero");
  if (!section) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        section.classList.add("show");
        observer.disconnect(); // run once
      }
    },
    { threshold: 0.4 }
  );

  observer.observe(section);

  return () => observer.disconnect();
}, []);

    
    const [cards, setCards] = useState(cardData);


    const rotateCards = () => {
        const frontCard = document.querySelector(".career-card");

        if (!frontCard) return;

        // STEP 1: Lift the card (stand up)
        frontCard.classList.add("card-lift");

        // STEP 2: Send it backward
        setTimeout(() => {
            frontCard.classList.remove("card-lift");
            frontCard.classList.add("card-send-back");
        }, 220);

        // STEP 3: After animation → rotate array
        setTimeout(() => {
            setCards((prev) => {
                const updated = [...prev];
                const first = updated.shift();
                updated.push(first);
                return updated;
            });

            // Clean state
            frontCard.classList.remove("card-send-back");
        }, 520);
    };


    return (


        <>




            <section className="career-hero">
                <div className="career-hero-inner">
                    {/* LEFT */}
                    <div className="career-hero-left">
                        <h1><span className='cm'>Creative minds</span> belong where excellence is built.</h1>
                        <p>Join a team that values ideas, ownership, and real-world impact — not just job titles.</p>

                        {/* <div className="career-search">
                        <input placeholder="Job title or keyword" />
                        <input placeholder="All locations" />
                        <button>🔍</button>
                    </div> */}
                    </div>

                    {/* RIGHT */}
                    <div className="career-hero-right">


                        <div className="career-card-stack" onClick={rotateCards}>
                            {cards.map((card, index) => (
                                <div
                                    key={card.id}
                                    className="career-card"
                                    style={{
                                        transform: `translate(${index * 20}px, ${index * 14
                                            }px) scale(${1 - index * 0.05})`,
                                        zIndex: cards.length - index,
                                    }}
                                >
                                    <img src={card.img} alt="profile" />
                                    <div className="career-card-info">
                                        {card.stats.split("\n").map((t, i) => (
                                            <span key={i}>{t}</span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </section>

            <FeaturedJobOffers />

        </>

    );
};

export default CareerHero;
